import { useEffect } from 'react'
import { Statistics } from './Statistics'
import * as Styles from './styles'
import useUserPermission from 'src/hooks/useUserPermissions'
import { USER_SCOPES } from 'src/hooks/UserPermission'

export const Dashboard = () => {
    const { validateUserScopeForPage } = useUserPermission()

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.DASHBOARD)
    }, [])

    return (
        <Styles.Container>
            <Statistics />
        </Styles.Container>
    )
}
